import { combineReducers, configureStore } from "@reduxjs/toolkit";
import cartSlice from './slices/cartSlice'
import layoutSlice from './slices/layoutSlice'
// import categorySlice from "./slices/categorySlice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

// The product layout keeps its document and source across reloads, but never
// the in-flight status or an edit-mode draft — a stale edit mode must not
// survive a refresh. Hence its own persist config and the root blacklist.
const layoutPersistConfig = {
    key: 'layout',
    storage,
    whitelist: ['layout', 'source'],
}

const rootReducer = combineReducers({
    cart: cartSlice,
    layout: persistReducer(layoutPersistConfig, layoutSlice),
    // category: categorySlice
})

const persistConfig = {
    key: 'root',
    storage,
    version: 3,
    blacklist: ['layout'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    })
})

export const persistor = persistStore(store);
